import CompletedOrdersModule from './CompletedOrders.module';

export default CompletedOrdersModule;
